<template>
	<main id='consultoria-modal' class='ohx'>
		<v-content class='pa-0 ohx' >
			<v-container fluid id='cotacao-modal' grid-list-xl class=' no-padding white-background ohx' >
				<v-layout row wrap>
					<v-flex xs12 class='form-title'> 
						<h1>Proposta Fianca (Visão Imobiliário)</h1>
						<span class='close-button' @click="$emit('close')"><v-icon >close</v-icon></span>
					</v-flex>
					</v-layout>
					<v-layout row wrap step-title form-padding>
						<v-flex xs12 >
							<span>1º Dados Gerais</span>
						</v-flex>
					</v-layout>
				</v-layout>
				<v-layout row wrap class='form-padding mt-4 '>
					<v-flex xs4 >
						<v-layout row wrap>
							<v-flex xs12>
								<v-text-field
									class='form-input-box'
									label='CPF / CNPJ do Locatário'
									placeholder=' '
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									class='form-input-box'
									label='CNPJ Corretor'
									placeholder=' '
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									class='form-input-box'
									label='CPF / CNPJ Locador'
									placeholder=' '
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									class='form-input-box'
									label='CEP'
									placeholder=' '
								></v-text-field>
							</v-flex>
							<v-flex xs4>
								<v-text-field
									class='form-input-box'
									label='Número '
									placeholder=' '
								></v-text-field>
							</v-flex>
							<v-flex xs8>
								<v-text-field
									class='form-input-box'
									label='Complemento'
									placeholder=' '
								></v-text-field>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs4>
						<v-layout row wrap>
							<v-flex xs12>
								<div class="form-grey-box">
									<v-text-field
										class='grey-box-input mb-3'
										label='Nome / Razão Social Locatário'
										placeholder=' '
									>
									</v-text-field>
									<v-text-field
										class='grey-box-input'
										label='Endereço'
										placeholder=' '
									>
									</v-text-field>
								</div>
							</v-flex>
							<v-flex xs12>
								<div class="form-grey-box">
									<v-text-field
										class='grey-box-input mb-3'
										label='Razão Social Corretor'
										placeholder=' '
									>
									</v-text-field>
								</div>
							</v-flex>
							<v-flex xs12>
								<div class="form-grey-box">
									<v-text-field
										class='grey-box-input mb-3'
										label='Razão Social Locador'
										placeholder=' '
									>
									</v-text-field>
								</div>
							</v-flex>
							<v-flex xs12>
								<div class="form-grey-box">
									<v-text-field
										class='grey-box-input mb-3'
										label='Endereço'
										placeholder=' '
									>
									</v-text-field>
								</div>
							</v-flex>
						</v-layout>

					</v-flex>
					<v-flex xs4 >
						<v-layout row wrap>
							<v-flex xs12>
								<div class="form-grey-box form-grey-box-list no-padding " >
							<v-layout row wrap class='limites-list'>
								<v-flex xs6 pb-0><span>Limites</span></v-flex>
								<v-flex xs6 pb-0 text-xs-right><span>Taxa 0.1345 %</span></v-flex>
								<ul>
									<li>
										<v-layout row wrap>
												<v-flex xs6>Aprovado</v-flex>
											<v-flex xs6 text-xs-right >R$500.000,00</v-flex>
										</v-layout>
									</li>
									<li>
										<v-layout row wrap>
											<v-flex xs6>Tomado</v-flex>
											<v-flex xs6 text-xs-right>R$500.000,00</v-flex>
										</v-layout>
									</li>
									<li>
										<v-layout row wrap>
											<v-flex xs6>Disponível</v-flex>
											<v-flex xs6 text-xs-right>R$500.000,00</v-flex>
										</v-layout>
									</li>
								</ul>
							</v-layout>
						</div>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
				<v-layout row wrap class='form-padding '>
					
				</v-layout>
				<v-layout row wrap class='form-padding '>
					
				</v-layout>
				<v-layout row wrap class='form-padding '>
					
				</v-layout>


				<v-layout row wrap class='step-title form-padding' v-if="step >= 2">
					
				</v-layout>
				<v-layout row wrap class='form-padding mt-4 second-block ' v-if="step >= 2">
					
				</v-layout>
				
				
				<v-layout row wrap class='' >
					<v-flex xs12 no-padding>
            <form-alert :type='alertText.type' :message='alertText.message' class='modal-alert'></form-alert>
          </v-flex>
				</v-layout>
				<v-layout row wrap class='step-title form-padding'>
					<v-flex xs4 class='border-right'>
						<span>2º Cálculo</span>
					</v-flex>
					<v-flex xs4 class='border-right'>
						<span>3º Coberturas</span>
					</v-flex>
					<v-flex xs4>
						<span>4º Valor</span>
					</v-flex>
				</v-layout>
				<v-layout row wrap class='form-padding mt-4 '>
					<v-flex xs4 >
						<v-layout row wrap>
							<v-flex xs4 >
								<v-text-field
									class='form-input-box'
									label='Aluguel'
									placeholder=' '
								>
								</v-text-field>
							</v-flex>
							<v-flex xs4 >
								<v-text-field
									class='form-input-box'
									label='Condomínio'
									placeholder=' '
								>
								</v-text-field>
							</v-flex>
							<v-flex xs4 >
								<v-text-field
									class='form-input-box'
									label='IPTU'
									placeholder=' '
								>
								</v-text-field>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs6>
								<v-text-field
									class='form-input-box'
									label='Vigência Início'
									placeholder=' '
								>
								</v-text-field>
							</v-flex>
							<v-flex xs3>
								<v-text-field
									class='form-input-box'
									label='Prazo Dias'
									placeholder=' '
								>
								</v-text-field>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs4>
								<v-text-field
									class='grey-box-input mb-3'
									label='Vigência Final'
									placeholder=' ' 
									hide-details
								>
								</v-text-field>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs6 no-padding-top no-padding>
								<v-btn class="button blue-button no-margin-top" @click="calc()">Calcular</v-btn>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs4>
						<v-layout row wrap>
							<v-flex xs1 class='checkbox-container'>
				        <v-checkbox v-model="checkboxes" hide-details class="shrink mr-2"></v-checkbox>
				      </v-flex>
				      <v-flex xs11>
								<v-text-field
									class='form-input-box'
									label='Cobertura Básica'
									placeholder=' '
								>
								</v-text-field>
							</v-flex>

							<v-flex xs1 class='checkbox-container'>
				        <v-checkbox v-model="checkboxes" hide-details class="shrink mr-2"></v-checkbox>
				      </v-flex>
				      <v-flex xs11>
								<v-text-field
									class='form-input-box'
									label='Cobertura Básica'
									placeholder=' '
								>
								</v-text-field>
							</v-flex>

							<v-flex xs1 class='checkbox-container'>
				        <v-checkbox v-model="checkboxes" hide-details class="shrink mr-2"></v-checkbox>
				      </v-flex>
				      <v-flex xs11>
								<v-text-field
									class='form-input-box'
									label='Cobertura Básica'
									placeholder=' '
								>
								</v-text-field>
							</v-flex>

							<v-flex xs1 class='checkbox-container'>
				        <v-checkbox v-model="checkboxes" hide-details class="shrink mr-2"></v-checkbox>
				      </v-flex>
				      <v-flex xs11>
								<v-text-field
									class='form-input-box'
									label='Cobertura Básica'
									placeholder=' '
								>
								</v-text-field>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs4 >
				
						<v-layout row wrap>
							<v-flex xs10>
								<v-text-field
									class='form-input-box'
									label='Premio a Vista'
									placeholder=' '
									
									mask="##.###.###/####-##"
								>
								</v-text-field>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex xs10>
								<div class="form-grey-box form-grey-box-list no-padding " >
									<v-layout row wrap class='limites-list'>
										<v-flex xs6 pb-0><span>Parcelamento</span></v-flex>
										<ul>
											<li>
												<v-layout row wrap>
													<v-flex xs6>2x de R$750,00</v-flex>
												</v-layout>
											</li>
											<li>
												<v-layout row wrap>
													<v-flex xs6>3x de R$500,00</v-flex>
												</v-layout>
											</li>
											<li>
												<v-layout row wrap>
													<v-flex xs6>2x de RR375,00</v-flex>
												</v-layout>
											</li>
										</ul>
									</v-layout>
								</div>
							</v-flex>
						</v-layout>
						<v-layout row wrap mt-3>
							<v-flex xs4>
								<v-text-field
									class='form-input-box'
									label='Data da Cotação'
									placeholder=' '
								>
								</v-text-field>
							</v-flex>
							<v-flex xs6>
								<v-text-field
									class='form-input-box'
									label='Nº da Cotação'
									placeholder=' '
								>
								</v-text-field>
							</v-flex>
						</v-layout>
					</v-flex>
						
				</v-layout>
				<v-layout row wrap class='form-padding border-top' v-if="step >= 2" >
					<v-flex xs2>
						<v-btn class="button blue-button inverted no-margin-top" @click="calc()">Sair e salvar</v-btn>
					</v-flex>
					<v-flex xs3>
						<v-btn class="button blue-button cancel inverted no-margin-top" @click="calc()">Desistir da Proposta</v-btn>
					</v-flex>
						<v-spacer></v-spacer>
					<v-flex xs3>
						<v-layout>
							<v-flex xs12 align-content-end align-end text-xs-right> 
								<v-btn class="button blue-button inverted no-margin-top icon remove-outline" @click="calc()"><v-icon>email</v-icon></v-btn>
								
							
								<v-btn class="button blue-button inverted no-margin-top icon remove-outline" @click="calc()"><v-icon>picture_as_pdf</v-icon></v-btn>
								
							</v-flex>
						</v-layout>
						
					</v-flex>
					<v-flex xs2>
						<v-btn class="button blue-button no-margin-top" @click="calc()">Submeter Análise</v-btn>
					</v-flex>
					
				</v-layout>


			</v-container>
		</v-content>
	</main>
</template>

<style lang='scss' scoped>
#jns {
  .form-title {
    position: relative;
    h1 {
      padding: 10px;
      font-size: 22px;
      font-weight: bold;
      color: #4e4e4e;
      text-align: center;
    }
    i {
      position: absolute;
      top: 25px;
      left: 25px;
    }
  }
  #cotacao-modal {
  }
  .checkbox-container {
    margin-top: 19px;
  }
  .step-title {
    background-color: #efefef;

    color: #4e4e4e;
    span {
      font-size: 18px;
      font-weight: bold;

      padding-right: 10px;
    }
  }
  .form-padding {
    padding-left: 40px;
    padding-right: 40px;
  }
  .form-input-box {
  }
  .cnpj-check-alert {
    color: #7ed321;
    font-weight: bold;
    font-size: 12px;
    i {
      color: #7ed321;
    }
  }

  .form-grey-box {
    padding: 25px;
    border-radius: 4px;
    background-color: #f7f7f7;
  }

  .limites-list {
    height: 171px;
    font-size: 12px;
    color: #4e4e4e;
    padding-left: 25px;
    padding-right: 25px;

    ul {
      list-style: none;
      padding-left: 0;
      margin-left: 0;
      width: 100%;

      li {
        margin-left: -12px;
        padding-left: 25px;
        margin-right: -12px;
        padding-right: 25px;
        font-size: 14px;
        font-weight: bold;
        color: #555;
        padding-bottom: 10px;
        padding-top: 10px;
        border-bottom: 1px solid #e8e8e8;
        &:last-of-type {
          border-bottom: 0;
        }
      }
    }
  }
  .no-padding {
    padding: 0;
  }
  .form-grey-box-list {
    margin-top: 6px;
  }
  .blue-button {
    min-width: auto;
    border-radius: 4px;
    background-color: #4589f3;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.09);
    font-weight: bold;
    color: #fff;
    transition: all 0.2s ease;
    line-height: 10px;
    width: 100%;
    margin-top: 16px;
    padding: 15px;
    &:hover {
      background-color: white;
      color: #4589f3;
    }

    &.cancel {
      border: 1px solid #f81c50;
      color: #f81c50;
    }

    &.inverted {
      border: 1px solid #4589f3;
      background-color: #fff;
      color: #4589f3;

      &:hover {
        background-color: #4589f3;
        color: white;
      }
    }
    &.icon {
      width: auto;
      padding: 0 0px;
      margin: 0;
      margin-top: 15px;
      display: inline-block;
      margin-left: 25px;
    }
    &.no-margin-top {
      margin-top: 0px;
    }

    &.cancel {
      border: 1px solid #f81c50;
      color: #f81c50;
      &:hover {
        background-color: #f81c50;
        color: white;
      }
    }
  }
  .border-right {
    border-right: 1px solid #e8e8e8;
    &.repositioning {
      margin-top: -25px;
      padding-top: 25px;
    }
  }
  .border-top {
    border-top: 1px solid #e8e8e8;
  }
  .ohx {
    overflow-x: hidden;
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
  }
  .close-button {
    cursor: pointer;
  }
}
</style>

<script lang="js">
import moment from "moment";

export default {
  name: "PropostaFianciaImobiliarioModal",
  data: () => ({
    drawer: null,
    firstLoadServiceRequest: true,
    step: 3,
    model: {},
    modalidades: [
      { text: "Modalidade 1" },
      { text: "Modalidade 2" },
      { text: "Modalidade 3" },
    ],
    checkboxes: true,
  }),

  computed: {
    filteredItems() {},
  },
  methods: {
    checkCnpj() {
      // this.step = 2
    },
    calc() {
      // this.step = 3
    },
  },

  mounted() {},
  props: [],
};
</script>





// WEBPACK FOOTER //
// ./src/components/PropostaFiancaImobiliarioModal.vue